import { TooltipProvider } from '@odo/shared-ui';
import React, { ReactNode } from 'react';
import { ResourceAuthoringProvider } from '../authoring/AuthoringContext';
import { CommandPaletteProvider } from '../context/CommandPaletteContext';
import { ResourcesLibraryProvider } from '../providers/resourcesLibraryProvider';
import CommandPalette from './CommandPalette';

/** Wraps a host's resources routes: one library load, one ⌘K layer, one authoring layer for the whole section. */
export const ResourcesShell: React.FC<{ children: ReactNode }> = ({ children }) => (
    // TooltipProvider: SolidStatusPill needs one; nesting under a host's is safe.
    <TooltipProvider>
        <ResourcesLibraryProvider>
            <ResourceAuthoringProvider>
                <CommandPaletteProvider>
                    {children}
                    <CommandPalette />
                </CommandPaletteProvider>
            </ResourceAuthoringProvider>
        </ResourcesLibraryProvider>
    </TooltipProvider>
);

export default ResourcesShell;
